import React, { useState } from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
} from 'recharts';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, Chip, Stack, Grid } from '@mui/material';
import RepairsPieChart from './RepairsPieChart';
import CallsPieChart from './CallsPieChart';
import TasksOverviewChart from './TasksOverviewChart';
import { NumericFormat } from 'react-number-format';

const dailyData = [
  { date: 'Mon', revenue: 1200, occupancy: 75 },
  { date: 'Tue', revenue: 980, occupancy: 68 },
  { date: 'Wed', revenue: 1450, occupancy: 80 },
  { date: 'Thu', revenue: 1320, occupancy: 72 },
  { date: 'Fri', revenue: 1600, occupancy: 90 },
  { date: 'Sat', revenue: 1800, occupancy: 95 },
  { date: 'Sun', revenue: 1500, occupancy: 88 },
];

const weeklyData = [
  { date: 'Week 1', revenue: 8700, occupancy: 73 },
  { date: 'Week 2', revenue: 9200, occupancy: 76 },
  { date: 'Week 3', revenue: 8900, occupancy: 70 },
  { date: 'Week 4', revenue: 9600, occupancy: 82 },
];
// let avgVacancy = 3;
// let totalRevenue =2150;
const RevenueOccupancyChart = ({dailyData, weeklyData}) => {
  const [mode, setMode] = useState('daily');
  // console.log(dailyData)
  const totalRevenue = weeklyData.reduce((sum, item) => sum + item.amount, 0);
  let avgVacancy = dailyData.reduce((sum, item) => sum + item.occupancy, 0)/dailyData.length;
  avgVacancy = Math.round(avgVacancy);
  const handleChange = (e) => {
    setMode(e.target.value);
  };

  const chartData = mode === 'daily' ? dailyData : weeklyData;

  return (
    <>
    <Box sx={{ p: 3, background: '#fff', borderRadius: 2, boxShadow: 1 }}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Revenue vs Vacancy 
          </Typography>
          <Typography variant="h4">
            <b style={{color:"#4caf50"}}>
              <NumericFormat value={totalRevenue} thousandSeparator prefix={'$'} displayType="text"/>
            </b>
            &nbsp;vs&nbsp;
            <b style={{color:"#f44336"}}>
              <NumericFormat value={avgVacancy} thousandSeparator suffix={' rooms'} displayType="text"/>
            </b>
          </Typography> 
        </Box>
        <FormControl size="small">
          <InputLabel>View</InputLabel>
          <Select value={mode} label="View" onChange={handleChange}>
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <ResponsiveContainer width="100%" height={395}>
        <ComposedChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis yAxisId="left" orientation="left" tickFormatter={(val) => `$${val}`} />
          <YAxis yAxisId="right" orientation="right" domain={[0, 12]} tickFormatter={(val) => `${val}`} />
          <Tooltip formatter={(val, name) => (name == 'Vacancy' ? `${val} rooms` : `$${val}`)} />
          <Legend />
          <Bar yAxisId="left" dataKey="amount" fill="#4caf50" name="Revenue" />
          <Line yAxisId="right" type="monotone" dataKey="occupancy" stroke="#f44336" name="Vacancy" strokeWidth={2} dot />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
    </>
  );
};

export default RevenueOccupancyChart;
